import { render, staticRenderFns } from "./GeneralSummary.vue?vue&type=template&id=3e3b3772&scoped=true&"
import script from "./GeneralSummary.vue?vue&type=script&lang=js&"
export * from "./GeneralSummary.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSummary.vue?vue&type=style&index=0&id=3e3b3772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3b3772",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardTitle,VIcon,VTextarea,VTooltip})
